export default {
  namespaced: true,
  name: 'cart',
  state: () => ({
    cartItems: [],
  }),
  mutations: {
    ADD_OR_UPDATE_PRODUCT_TO_CART(state, product) {
      const index = state.cartItems.findIndex((item) => item.index === product.index);
      if (index !== -1) {
        state.cartItems[index].quantity += product.quantity;
      } else {
        state.cartItems.push(product);
      }
    },
    REMOVE_PRODUCT_FROM_CART(state, productId) {
      const index = state.cartItems.findIndex((item) => item.id === productId);
      state.cartItems.splice(index, 1);
    },
    SET_CART_ITEMS(state, products) {
      state.cartItems = products;
    },
  },
  getters: {
    GET_COUNT: (state) => (state.cartItems.length ? state.cartItems.length : 0),
    GET_CART_ITEMS: (state) => state.cartItems,
    GET_CART_TOTAL: (state) => (state.cartItems.length ? state.cartItems.reduce((acc, item) => acc + (item.item_price * item.quantidade), 0).toFixed(2) : 0),
  },
  actions: {
    removeProductFromCart({ commit }, productId) {
      commit('REMOVE_PRODUCT_FROM_CART', productId);
    },
    fetchCartProducts({ commit, state }) {
      // fetch cart products from API
      return {
        data: state.cartItems,
      };
    },
    clearCart({ commit }) {
      commit('SET_CART_ITEMS', []);
    },
  },
};
